import React, { useMemo, useState } from 'react'
import Bread from '../components/Breadcrumb'
import { Tabs, Upload, Select, Input, Button, message } from 'antd'
import { AspirationsBread, EditControl, EGetTopic } from '../../models/constants'
import BraftEditor from 'braft-editor'
import { PictureFilled, UploadOutlined } from '@ant-design/icons'
import { ContentUtils } from 'braft-utils'

import { useParams } from 'react-router-dom'

import { NInfo, EPostInfo } from '../../models/constants'
import { effect, useStore } from '../../dva16'

import './index.less'
import 'braft-editor/dist/index.css'

const { TabPane } = Tabs
const { Option } = Select

function Edit() {
  const [editorState, setEditorState] = useState(BraftEditor.createEditorState(null))
  const [title, setTitle] = useState('')
  const [topicID, setTopicID] = useState(null)
  const [photos, setPhotos] = useState('')
  const [fileList, setFileList] = useState([])

  let { topic, category } = useStore(NInfo)
  let { categoryID } = useParams()
  //图片上传回调
  const uploadChange = (info, editorState) => {
    if (info.file.status === 'done') {
      // 富文本图片上传成功，将图片地址加入富文本内容
      let data = ContentUtils.insertMedias(editorState, [{ type: 'IMAGE', url: info.file.response.url }])
      setEditorState(data)
    } else if (info.file.status === 'error') {
      message.error('图片上传失败')
    }
  }

  const uploadIndex = (info) => {
    let fileList = [...info.fileList]
    fileList = fileList.slice(-1)
    setFileList(fileList)

    if (info.file.status === 'done') {
      // 首页大图的上传成功回调
      setPhotos(info.file.response.url)
    } else if (info.file.status === 'error') {
      message.error('图片上传失败')
    }
  }

  // 上传
  const handleClick = () => {
    let param = {}
    if (+categoryID !== 1 && +categoryID !== 3) {
      // 不存在index 图
      // if (title === '' || topicID === null) {
      if (title === '') {
        message.error('信息不完整')
        return
      }
      let data = []
      data.push(photos)
      param = { photos: data, title, topicID, categoryID, html: editorState.toHTML() }
    } else if (+categoryID === 3) {
      if (photos === '' || title === '') {
        message.error('信息不完整')
        return
      }
      let data = []
      data.push(photos)
      param = { photos: data, title, topicID, categoryID, html: editorState.toHTML() }
    } else {
      if (photos === '' || title === '') {
        message.error('信息不完整')
        return
      }
      let data = []
      data.push(photos)
      param = { photos: data, title, topicID, categoryID, html: editorState.toHTML() }
    }
    effect(NInfo, EPostInfo, param)
  }

  const uploadProps = {
    action: 'http://s.stgame.cn/k3/client/v1/file',
    accept: 'image/*',
  }

  const extendControls = [
    {
      key: 'antd-uploader',
      type: 'component',
      component: (
        <Upload {...uploadProps} onChange={(info) => uploadChange(info, editorState)} showUploadList={false}>
          {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
          <button type="button" className="control-item button upload-button" data-title="插入图片">
            <PictureFilled />
          </button>
        </Upload>
      ),
    },
  ]

  useMemo(() => {
    effect(NInfo, EGetTopic, { categoryID })
  }, [])

  function computeWhichCategory() {
    let value
    if (category) {
      category.forEach((item) => {
        if (item.id === Number(categoryID)) {
          value = item
          return
        }
      })
    }
    return value
  }

  return (
    <div id="container">
      <div id="edit">
        {Bread(AspirationsBread, computeWhichCategory(category))}
        <div className="center">
          <Tabs defaultActiveKey="1">
            <TabPane tab="发表新帖" key="1">
              <div>
                <div className="editHeader">
                  {+categoryID !== 3 && (
                    <>
                      <span>话题</span>
                      <Select size="large" onChange={(value) => setTopicID(value)} placeholder="请选择话题" style={{ width: 176 }}>
                        {topic.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </>
                  )}
                  <span>标题</span>
                  <Input onChange={(e) => setTitle(e.target.value)} placeholder="请输入标题" />
                </div>
                <div className="richText">
                  <BraftEditor
                    value={editorState}
                    controls={EditControl}
                    onChange={(editorState) => {
                      setEditorState(editorState)
                    }}
                    extendControls={extendControls}
                  />
                </div>
              </div>
            </TabPane>
          </Tabs>
          <div className="button">
            {/*{(+categoryID === 1 || +categoryID === 3) && (*/}
            {/*  <div className="upload">*/}
            {/*    <Upload {...uploadProps} onChange={(info) => uploadIndex(info)} fileList={fileList}>*/}
            {/*      <Button>*/}
            {/*        <UploadOutlined />*/}
            {/*        上传封面图*/}
            {/*      </Button>*/}
            {/*    </Upload>*/}
            {/*  </div>*/}
            {/*)}*/}
            <div className="upload">
              <Upload {...uploadProps} onChange={(info) => uploadIndex(info)} fileList={fileList}>
                <Button>
                  <UploadOutlined />
                  上传封面图
                </Button>
              </Upload>
            </div>
            <div>
              <Button onClick={() => handleClick()} className="release">
                点击发布
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Edit
